import * as React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { styled } from "@mui/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import "./Layout.css";
const pictureUrl = sessionStorage.getItem("pictureUrl");

const mdTheme = createTheme({
  palette: {
    background: {
      paper: "",
      bg: "",
    },
    text: {
      primary: "#173A5E",
      secondary: "#46505A",
    },
  },
});

function Layout(props) {
  let { lang } = useParams();
  const { i18n } = useTranslation();

  React.useEffect(async () => {
    await i18n.changeLanguage(lang);
    sessionStorage.setItem('lang', lang);
  }, []);

  return (
    <ThemeProvider theme={mdTheme}>
      <Box
        sx={{ display: "block", justifyContent: "center", width: "100%" }}
        className="root-background"
      >
        <CssBaseline />
        <Box component="main">
          <Box className="root-banner">
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              className="root-logo"
            >
              <Box
                component="img"
                src="/img/logo-lucklanding.png"
                className="logo-biggame"
              />
            </Box>
          </Box>
          <Container
            sx={{ boxShadow: "none", mt: 2, pb: 5, px: 0 ,minWidth: 335}}
            disableGutters
          >
            {props.children}
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  );
}
export default Layout;
